import { ExportType } from '@components'

import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useCsvExport } from '@features/exports/hooks/useCsvExport'
import { useXlsxExport } from '@features/exports/hooks/useXlsxExport'
import { ReportsExportButton } from '@views/reports/elements/ReportsExportButton'
import { useReportPdfExport } from '@views/reports/hooks/useReportPdfExport'

import { NotificationKeys } from '../../../../../../../enums/notificationKeys'
import { ReportsType } from '../../../../../enums/reportsType'
import { useTrialBalanceFilters } from '../../contexts/trialBalanceFiltersContext'
import { useTrialBalanceData } from '../../hooks/useTrialBalanceData'
import { useTrialBalanceSpreadSheetExportData } from '../../hooks/useTrialBalanceSpreadSheetExportData'

export const TrialBalanceSideActions = () => {
  const { t } = useTranslation()

  const { reportData, isLoading: isLoadingReportData } = useTrialBalanceData()
  const { appliedFilters } = useTrialBalanceFilters()
  const { allExpandableIds } = useTrialBalanceData()
  const { spreadSheetData } = useTrialBalanceSpreadSheetExportData()

  const { exportAsPdf, isLoading: isLoadingPdfExport } = useReportPdfExport({
    allExpandableIds,
    appliedFilters,
    fileName: t('reports.export.file_name.trial_balance'),
    reportData,
    reportType: ReportsType.TrialBalance,
    title: t('reports.trial_balance'),
  })

  const { exportAsCsv, isLoading: isLoadingCsvExport } = useCsvExport({
    spreadSheetData,
    fileName: t('reports.export.file_name.trial_balance'),
    notificationKey: NotificationKeys.ReportsExportCsv,
  })

  const { exportAsXlsx, isLoading: isLoadingXlsxExport } = useXlsxExport({
    spreadSheetData,
    fileName: t('reports.export.file_name.trial_balance'),
    notificationKey: NotificationKeys.ReportsExportXlsx,
  })

  const handleSelect = useCallback(
    (_: string, type: ExportType) => {
      switch (type) {
        case ExportType.Pdf:
          return exportAsPdf()
        case ExportType.Csv:
          return exportAsCsv()
        case ExportType.Xlsx:
          return exportAsXlsx()
      }
    },
    [exportAsCsv, exportAsPdf, exportAsXlsx],
  )

  const isLoading = isLoadingReportData || isLoadingPdfExport || isLoadingCsvExport || isLoadingXlsxExport

  return <ReportsExportButton disabled={isLoading} loading={isLoading} onSelect={handleSelect} />
}
